import type { ElectricityData } from './types';

/** Réseau « test PUC » (eau chaude) as captured on integration: one auxiliary electricity contract. */
export const INITIAL_ELECTRICITY: ElectricityData = {
    powerContracts: [
        {
            id: 'pc-test',
            name: 'test',
            linkedSites: 0,
            linkedUnits: 1,
            linkedPumpGroups: 1,
            startDate: '2026-01-01',
            endDate: '2026-12-31',
            fixedPrice: 65,
            description: '',
            defaultMaxPower: null,
            defaultOverrunPrice: null,
        },
    ],
};

/** Production `FORM_NAME_MAX_LENGTH` for the electricity contract form. */
export const POWER_CONTRACT_NAME_MAX = 44;
